var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.theme.form)},[_c('div',[_vm._v("ログアウトしますか？")]),_vm._v(" "),_c('div',{style:(_vm.theme.actionRow)},[_c('button',{style:(_vm.theme.action),on:{"click":_vm.signOut}},[_vm._v("ログアウトする")])]),_vm._v(" "),(_vm.error)?_c('div',{style:(_vm.theme.error)},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af39c224","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/amplify/components/auth/SignOut.vue
// module id = null
// module chunks = 